import { Component, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable, Subscription, BehaviorSubject, combineLatest, of } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Site } from '../admin-dashboard/company-sites/company-site.model';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../shared/config';
import { CompanyUserService } from '../admin-setting/assing-company-users/company-user.service';
import { ProductService } from '../admin-dashboard/product/product.service';
import { StockingServiceService } from '../stocking/stocking-service.service';
import { environment } from '../../environments/environment';


@Component({

  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {

  sites: Site[];
  @ViewChild('drawer', { static: false }) public sidenav: MatSidenav;
  user$: Observable<any>;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 960px)'])
    .pipe(
      map(result => result.matches)
    );
  handsetSub: Subscription;
  isMobile: boolean;
  haveCompanyID = false;
  companies$: Observable<any>;
  selectedCompany: string;
  _isSuperAdmin: boolean = false;
  _canSeePowerOfficeLog: boolean = false;
  _isDriverManager: boolean = false;
  _userObj;
  productPerimission: boolean = true;
  orderPerimission: boolean = false;
  settingPermission: boolean = false;
  categoryPermission: boolean = false;
  routinesPermission: boolean = false;
  supportPermission: boolean = false;
  salesReportPermission: boolean = false;
  companyReportPermission: boolean = false;
  campaignPermission: boolean = false;
  stockingPermission: boolean = false;
  extraDeliveriesPermission: boolean = false;
  systemConfigsPermission: boolean = false;
  overview: boolean = false;
  couponPermission: boolean = false;

  lastConnectionPermisson: boolean = false;
  productRegulering: boolean = false;
  stockingPermisson: boolean;

  linkToGrafana: string = null;

  // Pending portal møtemat orders for the selected company — a badge on
  // Extra Deliveries so an admin does not need to open the page to know
  // something is waiting. Re-read on every company switch and on every
  // fresh user-permission read (companyChange$'s initial value covers the
  // very first load, before stockingPermisson is known).
  pendingCateringCount = 0;
  private companyChange$ = new BehaviorSubject<void>(undefined);

  constructor(private companyUserService: CompanyUserService,
    private stockingService: StockingServiceService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private afAuth: AngularFireAuth,
    private productService: ProductService,
    private configService: ConfigService,
    public authService: AuthService) {

    this.handsetSub = this.isHandset$.subscribe(isMobile => {
      this.isMobile = isMobile;
    })

    this.authService.getUser$().subscribe(userInfo => {
      // console.log(userInfo)
      this.productPerimission = userInfo['products'] as boolean;
      this.settingPermission = userInfo['settings'] as boolean;
      this.orderPerimission = userInfo['orders'] as boolean;
      this.categoryPermission = userInfo['category'] as boolean;
      this.routinesPermission = userInfo['routines'] as boolean;
      this.salesReportPermission = userInfo['salesReport'] as boolean;
      this.productRegulering = userInfo['productRegulering'] as boolean;
      this.companyReportPermission = userInfo['companyReportPermission'] as boolean;
      this.supportPermission = userInfo['support'] as boolean;
      this.overview = userInfo['overview'] as boolean;
      this.campaignPermission = userInfo['campaignPermission'] as boolean;
      this.lastConnectionPermisson = userInfo['lastConnection'] as boolean;
      this.stockingPermisson = userInfo['stocking'] as boolean;
      this.extraDeliveriesPermission = userInfo['extraDeliveries'] as boolean;
      this.systemConfigsPermission = userInfo['systemConfigs'] as boolean;
      this.couponPermission = userInfo['coupons'] as boolean;
      this._isSuperAdmin = userInfo['isSuperAdmin'];
      this.authService.isDriverManager().then(m => this._isDriverManager = m);
      this.authService.canSeePowerOfficeLog().then(v => this._canSeePowerOfficeLog = v);


      this.selectedCompany = this.currentCompany();
      this.companyChange$.next();
    });

    this.companyChange$.pipe(
      switchMap(() => (this.stockingPermisson || this._isSuperAdmin) ? this.stockingService.getExtraDelivery$() : of([]))
    ).subscribe((list: any[]) => {
      this.pendingCateringCount = (list || [])
        .filter(o => o.source === 'portal' && o.status === 'Pending approval').length;
    });



    // this.siteService.siteChanged.subscribe((sites: Site[])=>{
    //   console.log("sites", sites)
    //   this.sites = sites
    // })
    this.user$ = this.afAuth.authState;

    this.companies$ = combineLatest(this.authService.getUser$(), this.companyUserService.getCompanies$()).pipe(map(data => {
      // console.log("Data", data)
      const companyData = data[1].sort((a, b) => a['name'].localeCompare(b['name']))

      // Put cuboid on top
      const frigg = ["XTIVyzLbKPuJCLBiUDDp", "IbYFkxDI8RbMdRiukALO"];

      frigg.forEach(friggId => {
        const cuboidIndex = companyData.findIndex(obj => obj['companyId'] == friggId);
        if (cuboidIndex > -1) {
          const cuboid = companyData.splice(cuboidIndex, 1);
          companyData.unshift(cuboid[0]);
        }
      });

      const filterdCompanyData = companyData.filter(arr => {
        return data[0].companyId.includes(arr['companyId'])
      });

      return filterdCompanyData;

    }))

  }

  closeNav() {
    if (this.isMobile)
      this.sidenav.close()
  }

  // Opens the Jofemar vending-machine license renewal dashboard (separate
  // Next.js app) in a new tab, passing along a Firebase ID token so its
  // /api/auth/sso route can verify the user without a second login.
  async openJofemarLicenseRenewal() {
    this.closeNav();
    const token = await this.authService.getToken();
    window.open(`${environment.jofemarUrl}/api/auth/sso?token=${encodeURIComponent(token as string)}`, '_blank');
  }

  // Survey Forms (separate Next.js app): same SSO hand-off as the license
  // renewal app — a Firebase ID token proves to its /api/auth/sso route that
  // this is a Frigg super admin, so no second login.
  async openSurveyForms() {
    this.closeNav();
    const token = await this.authService.getToken();
    window.open(`${environment.surveyFormsUrl}/api/auth/sso?token=${encodeURIComponent(token as string)}`, '_blank');
  }

  goHome() {
    this.router.navigate(['/dashboard/sites'])
  }

  changeCompany(event) {
    let id = event.value;
    // this.selectedCompany = id;
    this.productService.changeCompanyResetProduct();
    this.configService.changeCompanyId(id)
    this.companyChange$.next();


    localStorage.setItem("siteFilter", "");
    // console.log("clicked,", id)
  }

  currentCompany() {
    return this.configService.getCompanyId()
  }

  getCompanyIds() {

    return this.configService.getComapnyIdList()
  }

  isActiveSites() {
    //console.log(site, this.router.url == "/sites/" + site);
    return this.router.url == "/dashboard/sites";
  }

  isActiveProducts(site) {
    //console.log(site, this.router.url == "/sites/" + site);
    return this.router.url == "/dashboard/products";
  }
  isActiveProductsNew(site) {
    //console.log(site, this.router.url == "/sites/" + site);
    return this.router.url == "/dashboard/products/new";
  }

  openGrafana() {

    this.authService.getToken().then(token => {
      this.linkToGrafana = `https://main.friggkantine.no/service/grafana/?token=${token}`;
      window.open(this.linkToGrafana, "_blank");
    });


  }

  goto(siteId) {
    console.log("Site: ", siteId);
    this.router.navigateByUrl("dashboard/sites/" + siteId)
  }
  onLogout() {
    this.authService.logout()
    //this.router.navigate(['/signin'])
  }
}
